import React from 'react';
import RatingItem from "./RatingItem";
import FrontSliderBlurb from "./FrontSliderBlurb";
import {contentURL} from "src/utilities/utilityFunctions";

const DrawWithFriendsSlide = () => {
    return (
        <div className="ls-slide" data-ls="slidedelay:8000; transition2d: all;" style={{width:"100%"}} id="drawWithFriendsSlide">

            <img src={contentURL() + "/site/images/layerslider-gallery-tn/chalk-girl.png"} className="ls-bg" alt="Slide background"/>

            <img className="ls-l"
                 style={{top:"0px",left:"18px",transform:"rotate(100deg)", msTransform:"rotate(100deg)", WebkitTransform:"rotate(100deg)", whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:0;delayin:0;parallaxlevel:0;easingin:easeOutElastic;"
                 src={contentURL() + "/site/images/layerslider-gallery/draw.png"} alt="" />

            <img className="ls-l"
                 style={{top:"7px",left:"407px",transform:"rotate(60deg)", msTransform:"rotate(60deg)", WebkitTransform:"rotate(6100deg)", whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:-250;delayin:400;parallaxlevel:2;easingin:easeOutElastic;"
                 src={contentURL() + "/site/images/layerslider-gallery/with2.png"} alt="" />

            <img className="ls-l"
                 style={{top:"7px",left:"617px",transform:"rotate(60deg)", msTransform:"rotate(60deg)", WebkitTransform:"rotate(6100deg)", whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:-250;delayin:600;parallaxlevel:1;easingin:easeOutElastic;"
                 src={contentURL() + "/site/images/layerslider-gallery/friends2.png"} alt="" />

            <img className="ls-l"
                 style={{top:"-16px",left:"904px",transform:"rotate(60deg)", msTransform:"rotate(60deg)", WebkitTransform:"rotate(6100deg)", whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:-250;delayin:900;parallaxlevel:4;easingin:easeOutElastic;"
                 src={contentURL() + "/site/images/layerslider-gallery-tn/bungee-kid.png"} alt="" />

            <img className="ls-l"
                 style={{top:"12px",left:"-555px",transform:"rotate(60deg)", msTransform:"rotate(60deg)", WebkitTransform:"rotate(6100deg)", whiteSpace: "nowrap"}}
                 data-ls="offsetxin:-250;offsetyin:0;delayin:1200;parallaxlevel:3;easingin:easeOutElastic;"
                 src={contentURL() + "/site/images/layerslider-gallery-tn/twin.png"} alt="" />

            <img className="ls-l"
                 style={{top:"360px",left:"-100px",transform:"rotate(60deg)", msTransform:"rotate(60deg)", WebkitTransform:"rotate(6100deg)", whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:300;delayin:1700;parallaxlevel:1;"
                 src={contentURL() + "/site/images/layerslider-gallery-tn/banner2.png"} alt="" />

            <img className="ls-l"
                 style={{top:"15px",left:"1095px",transform:"rotate(100deg)", msTransform:"rotate(100deg)", WebkitTransform:"rotate(100deg)", whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:700;parallaxlevel:4;"
                 src={contentURL() +  "/site/images/layerslider-gallery/common-swirl.png"} alt="" />

            <img className="ls-l"
                 style={{top:"133px",left:"536px",transform:"rotate(50deg)", msTransform:"rotate(50deg)", WebkitTransform:"rotate(50deg)", whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:1800;rotatexin:30;rotateyin:30;parallaxlevel:3;"
                 src={contentURL() + "/site/images/layerslider-gallery/common-swirl.png"} alt="" />

            <img className="ls-l"
                 style={{top:"516px",left:"705px",transform:"rotate(-50deg)", msTransform:"rotate(-50deg)", WebkitTransform:"rotate(-50deg)", whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:1800;rotatexin:30;rotateyin:30;parallaxlevel:2;"
                 src={contentURL() + "/site/images/layerslider-gallery/common-swirl.png"} alt="" />

            <img className="ls-l"
                 style={{top:"229px",left:"1069px",transform:"rotate(-90deg)", msTransform:"rotate(-90deg)", WebkitTransform:"rotate(-90deg)", whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:2500;rotatexin:30;rotateyin:30;parallaxlevel:3;"
                 src={contentURL() + "/site/images/layerslider-gallery/common-swirl.png"} alt="" />

            <img className="ls-l" style={{top:"123px",left:"1123px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:150;delayin:3000;rotateyin:100;offsetxout:0;offsetyout:-100;parallaxlevel:-4;"
                 src={contentURL() +  "/site/images/layerslider-gallery/star-2.png"}
                 alt="" />

            <img className="ls-l"
                 style={{top:"112px",left:"-70px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:90;delayin:2000;rotatexin:100;rotateyin:100;offsetyout:-90;parallaxlevel:1;"
                 src={contentURL() +  "/site/images/layerslider-gallery/swirl-3.png"}
                alt="" />

            <img className="ls-l"
                 style={{top:"197px",left:"-499px",whiteSpace: "nowrap"}}
                 data-ls="delayin:800;rotatexin:200;rotateyin:200;parallaxlevel:3;"
                 src={contentURL() +  "/site/images/layerslider-gallery/swirl-2.png"}
                alt="" />

            <img className="ls-l"
                 style={{top:"35px",left:"555px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:2200;rotatexin:90;rotateyin:90;offsetxout:0;parallaxlevel:2;"
                 src={contentURL() + "/site/images/layerslider-gallery/swirl-4.png"}
                 alt="" />

            <img className="ls-l"
                 style={{top:"395px",left:"758px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:3200;scalexin:4;scaleyin:4;offsetxout:0;parallaxlevel:-2;"
                 src={contentURL() + "/site/images/layerslider-gallery/common-star.png"}
                 alt="" />

            <img className="ls-l"
                 style={{top:"366px",left:"1067px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:2100;scalexin:2;scaleyin:2;offsetxout:0;parallaxlevel:1;"
                 src={contentURL() + "/site/images/layerslider-gallery/common-star.png"}
                 alt="" />

            <img className="ls-l"
                 style={{top:"444px",left:"1100px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:2400;scalexin:3;scaleyin:3;offsetxout:0;parallaxlevel:-1;"
                 src={contentURL() + "/site/images/layerslider-gallery/common-star.png"}
                 alt="" />

            <img className="ls-l"
                 style={{top:"561px",left:"955px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;durationin:1500;delayin:3600;scalexin:6;scaleyin:6;offsetxout:0;parallaxlevel:-2;"
                 src={contentURL() + "/site/images/layerslider-gallery/common-star.png"}
                 alt="" />

            <img className="ls-l"
                 style={{top:"197px",left:"-499px",whiteSpace: "nowrap"}}
                 data-ls="delayin:800;rotatexin:200;rotateyin:200;parallaxlevel:3;"
                 src={contentURL() + "/site/images/layerslider-gallery/swirl-2.png"}
                 alt="" />

            <img className="ls-l"
                 style={{top:"35px",left:"-250px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:2200;rotatexin:90;rotateyin:90;offsetxout:0;parallaxlevel:2;"
                 src={contentURL() + "/site/images/layerslider-gallery/swirl-4.png"}
                 alt="" />

            <img className="ls-l"
                 style={{top:"395px",left:"=450px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:3200;scalexin:4;scaleyin:4;offsetxout:0;parallaxlevel:-2;"
                 src={contentURL() + "/site/images/layerslider-gallery/common-star.png"}
                 alt="" />

            <img className="ls-l"
                 style={{top:"366px",left:"-600px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:2100;scalexin:2;scaleyin:2;offsetxout:0;parallaxlevel:1;"
                 src={contentURL() + "/site/images/layerslider-gallery/common-star.png"}
                 alt="" />

            <img className="ls-l"
                 style={{top:"444px",left:"-500px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:2400;scalexin:3;scaleyin:3;offsetxout:0;parallaxlevel:-1;"
                 src={contentURL() + "/site/images/layerslider-gallery/common-star.png"}
                 alt="" />

            <img className="ls-l"
                 style={{top:"561px",left:"-250px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;durationin:1500;delayin:3600;scalexin:6;scaleyin:6;offsetxout:0;parallaxlevel:-2;"
                 src={contentURL() + "/site/images/layerslider-gallery/common-star.png"}
                 alt="" />
            <div className="ls-l"
                     style={{top:"105px",left:"1350px"}}
                     data-ls="offsetxin:500;offsetyin:0;delayin:3500;easingin:easeOutQuart;offsetxout:500;offsetyout:0;parallaxlevel:1;"
                     key="blurb"
                >
                    <FrontSliderBlurb delay="0" show="true"
                                          blurb={"Invite a friend to draw with you. Color the same picture or do your own thing together."}/>
            </div>
                <RatingItem yeatitle={"...I LOVE this!!"}
                            mehtitle={"...I could go for it. Maybe."}
                            naytitle={"...I don't see the point."} bgcolor={"#EEEEEE"}
                            top={450} left={1050}
                            audience={"adult"}
                            feature={"drawwf"} label={"As an adult..."} key="sliderImage16"/>,
                <RatingItem yeatitle={"LOVE this!!"}
                            mehtitle={"take It Or Leave It"}
                            naytitle={"not like this."} bgcolor={"#EEEEEE"}
                            top={459} left={1050} audience={"child"}
                            feature={"drawwf"}
                            label={"My child will..."}
                            key="sliderImage17"/>
        </div>
    )
};

export default DrawWithFriendsSlide;
